import { useCallback } from "react";
import { useIntegrationConnectionFixingMutation } from "../../api/integrationConnection.api";
import { IntegrationConnection } from "../../common/types/integrationConnection";
import { useInteraction } from "../../hooks/useInteraction";
import { ExtendedButtonProps } from "../general/Button/Button";
import { ButtonWithLoader } from "../general/ButtonWithLoader/ButtonWithLoader";
import { usePayPalAuthorization } from "./usePayPalAuthorization";

interface Props extends Omit<ExtendedButtonProps, "onClick"> {
    children: React.ReactNode;
    connection: IntegrationConnection;
}

export const FixPayPalConnection: React.FC<Props> = ({
    children,
    connection,
    ...btnProps
}) => {
    const fixConnectionMutation =
        useIntegrationConnectionFixingMutation(connection);
    const fixConnection = useCallback(
        (authCode: string, sharedId: string) => {
            fixConnectionMutation.mutate({
                customParams: {
                    authCode,
                    sharedId,
                },
            });
        },
        [fixConnectionMutation],
    );
    const { initializeConnection } = usePayPalAuthorization(fixConnection);
    const authorize = useInteraction(initializeConnection);

    return (
        <ButtonWithLoader
            loading={fixConnectionMutation.isPending}
            variant={btnProps.variant}
            size={btnProps.size}
            className={btnProps.className}
            {...authorize}
        >
            {children}
        </ButtonWithLoader>
    );
};
